import React from 'react'
import PropTypes from 'prop-types'

import appleButtonEn from 'components/images/apple/en_add_to_apple_wallet.svg'
import appleButtonDe from 'components/images/apple/de_add_to_apple_wallet.svg'
import appleButtonFr from 'components/images/apple/fr_add_to_apple_wallet.svg'
import appleButtonNb from 'components/images/apple/nb_add_to_apple_wallet.svg'

const AppleButton = ({ token, t, locale, action }) => {
  const lang = locale.substr(0, 2)

  const walletButtons = {
    en: appleButtonEn,
    de: appleButtonDe,
    fr: appleButtonFr,
    nb: appleButtonNb,
  }

  const appleButtonImg = walletButtons[lang] ?? walletButtons.en

  return (
    <React.Fragment>
      <a href={token.pass.link_url} onClick={action}>
        <img src={appleButtonImg} alt={t('pages.membership.access.nfc.add_to_wallet.apple')}
          className='apple add'
        />
      </a>
    </React.Fragment>
  )
}

AppleButton.propTypes = {
  token: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
}

export default AppleButton
